import { useEffect, useContext } from 'react';
import Loader from '../NavBar/Loader/Loader';
import { loadingContext, loginContext } from '../../Context';
import { Container, Col, Row } from 'react-bootstrap';

const Logout = () => {
    const loadingCtx = useContext(loadingContext);
    const { logout } = useContext(loginContext);

    const handleLogout = () => {
        loadingCtx.dispatch({ type: "on" });

        logout();

        setTimeout(() => {
            loadingCtx.dispatch({ type: "off" });
            window.location.href = '/login_register';
        }, 1000);
    };

    useEffect(() => {
        handleLogout();
    }, []);

    return (
        <div className="content">
            <div className="tabcontent">
                <Container className="login-register-container">
                    <Row>
                        <Col sm={1}><Loader /></Col>
                        <Col sm={11}>
                            <p className='success'>Logout successful! Redirecting...</p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default Logout;
